import type { FC } from 'react';

import type { User } from '../../../../../../types/domain/user/user';
import { ImpersonateAction } from './ImpersonateAction';

export type Props = Readonly<{
  onReset: () => void;
  isLoading: Readonly<boolean>;
  user: Readonly<User>;
  canImpersonateUser: Readonly<boolean>;
  targetTenantSubdomain: Readonly<string | null>;
}>;

export const UserHighlightsImpersonateAction: FC<Props> = ({
  onReset,
  isLoading,
  user,
  canImpersonateUser,
  targetTenantSubdomain,
}) => {
  if (!canImpersonateUser || !targetTenantSubdomain) {
    return null;
  }

  return (
    <ImpersonateAction
      onReset={onReset}
      isLoading={isLoading}
      targetTenantSubdomain={targetTenantSubdomain}
      targetUserId={user.id}
    />
  );
};
